export function structuredCloneWithFallback<T>(value: T): T {
  return typeof window.structuredClone === 'function'
    ? window.structuredClone(value)
    : JSON.parse(JSON.stringify(value));
}
